// Import model
import { CatalogFeedCondition } from '../models/CatalogFeedCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { CatalogFeedIndexedFields } from '../models/CatalogFeedIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { CatalogFeedIndexedFieldsSerializer } from './CatalogFeedIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CatalogFeedCondition - handles JSON serialization and deserialization with type validation
 */
export class CatalogFeedConditionSerializer {
  /**
   * Deserializes a JSON string into a CatalogFeedCondition instance
   */
  static deserialize(json: string): CatalogFeedCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CatalogFeedCondition instance
   */
  static fromObject(obj: any): CatalogFeedCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CatalogFeedCondition');
    }


    const instance: CatalogFeedCondition = {
      fieldName: obj['fieldName'] as CatalogFeedIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CatalogFeedCondition instances
   */
  static deserializeArray(json: string): CatalogFeedCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CatalogFeedCondition instance to a JSON string
   */
  static serialize(instance: CatalogFeedCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CatalogFeedCondition instance to a plain object
   */
  static toObject(instance: CatalogFeedCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of CatalogFeedCondition instances to a JSON string
   */
  static serializeArray(instances: CatalogFeedCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
